import { ChainPath } from '@ankr.com/chains-list';

export interface CountryRequests {
  country: string;
  bytes?: number;
  requests: number;
}

type Count = number;

export type BlockchainsCountsMap = Record<ChainPath, Count>;

export type CountriesCountsMap = Record<string, CountryRequests>;

type UsageTimelineMapTimestamp = number;
export type UsageTimelineMap = Record<UsageTimelineMapTimestamp, Count>;

export enum StatsTimeframe {
  Hour = 1,
  TwoHours,
  Day,
  TwoDays,
  Week,
  Month,
}
